import { Lst } from "@/shared/lib/lst/lst";
import { backendApi } from "../../api";
import { base64ListRequest } from "@/services/backend/_lib/base64-list-request";
import { providesEntity } from "@/services/backend/_lib/tag-helpers";
import { SampleViewModel } from "@/services/backend/samples/types/sample-view-model";
import { Filter } from "@/shared/lib/filter/filter";
import { Kind } from "@/services/backend/samples/types/kind";
import { Namespace } from "@/shared/types/namespace";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { UUID } from "@bitory-gmbh/nidavellir";

const sampleApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    samplesViewModelShow: build.query<SampleViewModel, ShowRequest>({
      query: (request) => ({
        url: "/samples/sample",
        method: "GET",
        params: request,
      }),
      providesTags: providesEntity("SamplesSampleViewModel"),
    }),
    samplesViewModelList: build.query<Lst<SampleViewModel>, ListRequest>({
      query: (request) => ({
        url: "/samples/sample/list",
        method: "GET",
        params: base64ListRequest(request),
      }),
      providesTags: ["SamplesSampleViewModel"],
    }),
    samplesDeleteMany: build.mutation<null, DeleteRequest>({
      query: (request) => ({
        url: "/samples/sample",
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["SamplesSampleViewModel"],
    }),
  }),
});

export const {
  useSamplesViewModelShowQuery,
  useSamplesViewModelListQuery,
  useSamplesDeleteManyMutation,
} = sampleApi;

export type ShowRequest = {
  id: UUID;
};

export type ListRequest = {
  id?: Filter<UUID>;
  kind?: Filter<Kind>;
  document?: Filter<UUID>;
  documentNamespace?: Filter<Namespace>;
  number?: Filter<string>;
  location?: Filter<string>;
  spot?: Filter<string>;
  laboratory?: Filter<UUID>;
  delivery?: Filter<UUID>;
  orderBy?: OrdrBy<OrderByFields>[];
  limit?: number;
  offset?: number;
};

export type OrderByFields = "id" | "kind" | "number" | "location" | "spot";

export type DeleteRequest = {
  airMicrobialSampleSetIds: UUID[];
  dustDensitySampleIds: UUID[];
  surfaceMicrobialSampleSetIds: UUID[];
  waterSampleIds: UUID[];
};
